import { CountryCode, CountryCodes, CountryMap } from "content/CountryMap"
import { PhoneCodes } from "content/PhoneCodes"
import { ReactNode } from "react"

type PhoneCodeSelectOption = {
  id: CountryCode
  label: string
}

type FormSelectOption = { value: string | number; label: ReactNode | ReactNode[] }

const PhoneCodeSelectOptions: PhoneCodeSelectOption[] = CountryCodes.map((countryCode) => ({
  id: countryCode,
  label: `${CountryMap[countryCode]} (+${PhoneCodes[countryCode]})`
}))

const PhoneCodeSelectOptionsValues: FormSelectOption[] = CountryCodes.map((countryCode) => ({
  value: countryCode,
  label: `${CountryMap[countryCode]} (+${PhoneCodes[countryCode]})`
}))

export { PhoneCodeSelectOptions, PhoneCodeSelectOptionsValues }
